import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class SortableService {
  private _activeSortable$: BehaviorSubject<string> = null;

  initialize(): void {
    this._activeSortable$ = new BehaviorSubject<string>(null);
  }

  destroy(): void {
    this._activeSortable$.complete();
    this._activeSortable$ = null;
  }

  activeSortable$(): Observable<string> {
    return this._activeSortable$.asObservable();
  }

  updateActiveSortable(sortable: string) {
    this._activeSortable$.next(sortable);
  }
}
